import axios from 'axios';

const axiosInstance = axios.create({
    baseURL: 'https://fomoapps.com/api/v1'
});

// Add a request interceptor to automatically add Authorization header
axiosInstance.interceptors.request.use(
  (config) => {
    // Try to get the auth key from localStorage
    try {
      const authKey = JSON.parse(localStorage.getItem('authkey') || 'null');
      if (authKey && authKey !== 'null') {
        // Only add Authorization header if it's not already set
        // Check both 'Authorization' and 'authorization' (axios headers are case-insensitive)
        const hasAuthHeader = config.headers['Authorization'] || config.headers['authorization'];
        if (!hasAuthHeader) {
          config.headers['Authorization'] = `Bearer ${authKey}`;
        }
      }
    } catch (e) {
      // If parsing fails, just continue without auth header
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle 401 errors
axiosInstance.interceptors.response.use(
  (response) => {
    // Any status code that lies within the range of 2xx causes this function to trigger
    return response;
  },
  (error) => {
    // Any status codes that falls outside the range of 2xx causes this function to trigger
    if (error.response && error.response.status === 401) {
      // Clear the auth key from localStorage
      localStorage.removeItem('authkey');
      
      // Only redirect if not already on the login page or root
      const currentPath = window.location.pathname;
      const isLoginOrRoot = currentPath.includes('/login') || currentPath === '/' || currentPath === '';
      
      if (!isLoginOrRoot) {
        // Redirect to root path which is configured to show Login component
        // This works regardless of PUBLIC_URL setting since root always shows Login
        const publicUrl = process.env.PUBLIC_URL || '';
        const basePath = publicUrl ? (publicUrl.startsWith('/') ? publicUrl : `/${publicUrl}`) : '';
        window.location.href = `${basePath}/`;
      }
    }
    
    // Return the error so it can be handled by the calling code if needed
    return Promise.reject(error);
  }
);

export default axiosInstance;